var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57006 4.59988C3.37006 1.13988 8.58006 1.13988 9.37006 4.59988C9.84006 6.62988 8.55006 8.34988 7.43006 9.41988C6.61006 10.1999 5.32006 10.1899 4.50006 9.41988C3.39006 8.34988 2.10006 6.62988 2.57006 4.59988Z",
    stroke: "#0C0507",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 16.5999C16.37 13.1399 21.61 13.1399 22.41 16.5999C22.88 18.6299 21.59 20.3499 20.46 21.4199C19.64 22.1999 18.34 22.1899 17.52 21.4199C16.39 20.3499 15.1 18.6299 15.57 16.5999Z",
    stroke: "#0C0507",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 5H15.1799C17.0299 5 17.8899 7.29 16.4999 8.51L8.50995 15.5C7.11995 16.71 7.97994 19 9.81994 19H12.4999",
    stroke: "#0C0507",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98622 5.5H5.99777",
    stroke: "#0C0507",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9862 17.5H18.9978",
    stroke: "#0C0507",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting);
export default __webpack_public_path__ + "static/media/routing.8348924d8028577755e3b8f0b80e4946.svg";
export { ForwardRef as ReactComponent };